export default __webpack_public_path__ + "static/media/loading.e518f080.gif";